module.exports = __webpack_public_path__ + "media/src/images/abouts/items/stores/globalsports_1100-96b88d20ce5b19240a6c381af5216e3f.jpg";